import { render, staticRenderFns } from "./ProjectGroupDetailsAssembly.vue?vue&type=template&id=788e2c05&"
import script from "./ProjectGroupDetailsAssembly.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsAssembly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports